import React, { ReactNode } from 'react';
import { Reveal } from '../motion/Reveal';
type SectionHeadingProps = {
  id?: string;
  eyebrow?: string;
  title: string;
  intro?: ReactNode;
  onDark?: boolean;
  className?: string;
};
export function SectionHeading({
  id,
  eyebrow,
  title,
  intro,
  onDark = false,
  className = ''
}: SectionHeadingProps) {
  return <Reveal className={`max-w-2xl ${className}`} data-id="element-357" data-mp="rx7zzu78gpxc">
      {eyebrow && <p className={`flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.2em] ${onDark ? 'text-gold' : 'text-gold-deep'}`} data-id="element-358" data-mp="mzq3526hq15p">
          <span aria-hidden="true" className={`h-px w-6 ${onDark ? 'bg-gold' : 'bg-gold-deep'}`} data-id="element-359" data-mp="d8bxecny4544" />
          {eyebrow}
        </p>}
      <h2 id={id} className={`mt-5 font-serif text-[2.35rem] font-medium leading-[1.08] sm:text-5xl ${onDark ? 'text-white' : 'text-navy'}`} data-id="element-360" data-mp="8bd6e2zkwea5">
        {title}
      </h2>
      {intro && <div className={`mt-6 text-[17px] leading-relaxed ${onDark ? 'text-white/75' : 'text-muted'}`} data-id="element-361" data-mp="3vgue2q8dn817">{intro}</div>}
    </Reveal>;
}